import React, { Fragment, useEffect } from 'react';
import { isScriptEmbedded } from '../../../general/js/general-helpers';

const WeglotScript = ({
    options
}) => {
    useEffect(() => {
        const weglotCdn = 'https://cdn.weglot.com/weglot.min.js';

        if (!isScriptEmbedded(weglotCdn)) {
            const weglotSrcScript = document.createElement('script');
            weglotSrcScript.type = 'text/javascript';
            weglotSrcScript.src = weglotCdn;

            weglotSrcScript.onload = () => {
                const weglotInitScript = document.createElement('script');
                weglotInitScript.type = 'text/javascript';
                weglotInitScript.innerHTML = `Weglot.initialize({ api_key: "${options.apiKey}" });`;

                document.body.appendChild(weglotInitScript);
            };

            document.body.appendChild(weglotSrcScript);
        }
    });

    return <Fragment />;
};

export default WeglotScript;
